import { useEffect, useState } from "react";
import DocumentTitle from "react-document-title";
import { useHistory, useLocation } from "react-router";
import BackButton from "../../components/buttons/BackButton";
import CompetitionsService, { CompetitionsUsersWithNames, UserDataCompetition } from "../../services/CompetitionsService";
import styles from "./index.module.sass";
import Moment from "moment";
import { DefaultButton, Spinner, SpinnerSize } from "@fluentui/react";
import CompetitionCardFromCompetition from "../../components/competitionCardFromCompetition/CompetitionCardFromCompetition";
import Auth from "../../Auth/Auth";
import { TextField, DatePicker } from '@fluentui/react';
import { ISignature } from "../../services/SignaturesService";
import * as S from '@/components/ConvenienceTest/ConvenienceTest.style';
import { CompetitionSelectCont } from "@/components/competitionSelect/CompetitionSelect.style";
import { DatePickerStyle, InputStyles } from '@/components/GlobalStyle';
import Select from 'react-dropdown-select';
import CountryPrefixes from "../../utils/CountryPrefixes";
import { DayPickerStrings } from "../../components/ConvenienceTest/Utils/DatesTranlateFluents";
import { ErrorModal } from "../../components/Modals/ErrorModal";

const CompetitionInscriptionPromotionated = () =>
{
    const location = useLocation();
    const history = useHistory();

    const user = Auth.getUserProfile();

    // El estado de navegación no existe al recargar o entrar por enlace directo: se lee de forma segura para no lanzar un TypeError.
    // Si falta, los valores quedan undefined y la pantalla muestra el aviso de error (ver comprobación antes del render)
    const state = location?.state as { competitionInscripcion?: CompetitionsUsersWithNames } | undefined;
    const { competition, savingPlanName, portfolioModelName, competitionId, portfolioModelId, savingsPlanId } = state?.competitionInscripcion ?? ({} as CompetitionsUsersWithNames);

    const [loading, setLoading] = useState<boolean>(true);
    const [haveError, setHaveError] = useState<boolean>(false);
    const [sending, setSending] = useState<boolean>(false);

    const [error, setError] = useState({ status: false, message: "" });

    const [firstName, setFirstName] = useState<string>("");
    const [lastName, setLastName] = useState<string>("");
    const [secondLastName, setSecondLastName] = useState<string>("");
    const [mobile, setMobile] = useState<string>("");
    const [countryPrefix, setCountryPrefix] = useState<string>("+34");
    const [birthDayInDate, setBirthDayInDate] = useState<Date>();
    const [signatureCompetition, setSignatureCompetition] = useState<ISignature>();

    useEffect(() =>
    {
        CompetitionsService.getUserData(user.id).then((res) =>
        {
            res?.firstName != null && setFirstName(res.firstName);
            res?.lastName != null && setLastName(res.lastName);
            res?.secondLastName != null && setSecondLastName(res.secondLastName);
            res?.phone != null && setMobile(res.phone);
            res?.countryCode != null && setCountryPrefix(res.countryCode);
            res?.birthday != null && setBirthDayInDate(new Date(res.birthday))
        })
        .catch((error: any) =>
        {
            // No es bloqueante: el usuario puede rellenar sus datos a mano
            console.error("Error al cargar los datos del usuario para la competición", error);
        })
        .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if(location === undefined || state === undefined || state.competitionInscripcion === undefined || competition === undefined)
    {
        return(
            <DocumentTitle title="IronIA - Competiciones">
                <div>
                    <BackButton />
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12">
                            <h2>Competiciones </h2>
                        </div>
                    </div>
                    <p style={{marginTop: "20px"}}>Error: No hemos podido procesar tu petición. Porfavor, vuelve a intentarlo.</p>
                    <DefaultButton className="button tiny-primary-button" onClick={() => history.push("/competitions-promotioned")}>
                        Volver a competiciones
                    </DefaultButton>
                </div>
            </DocumentTitle>
        );
    }

    const handleBirthdayChange = (date: Date | null | undefined) =>
    {
        const endDateForDate = new Date(date!);
        setBirthDayInDate(endDateForDate!)
    };

    const validateInputs = () =>
    {
        if(firstName === undefined && firstName == null)
        {
            setHaveError(true);

            return false;
        }

        if(lastName === undefined && lastName == null)
        {
            setHaveError(true);

            return false;
        }

        if(mobile === undefined || mobile == null)
        {
            setHaveError(true);

            return false;
        }

        if(birthDayInDate === undefined || birthDayInDate == null)
        {
            setHaveError(true);

            return false;
        }

        return true;
    }

    const participate = async () =>
    {
        try
        {
            if(!validateInputs())
            {
                return;
            }

            setSending(true);
            const { email, id } = user;

            const data: UserDataCompetition =
            {
                email,
                idCompetition: competitionId,
                idModelPortfolio: portfolioModelId,
                idSavingPlan: savingsPlanId,
                mobile,
                firstName,
                lastName,
                secondLastName,
                userId: id,
                birthday: birthDayInDate!,
                countryCode: countryPrefix,
            };
            const res = await CompetitionsService.patchUserData(data);

            if(res.id)
            {
                history.push("/competition/nap/contract", { competitionUserObject: res, competition: competition })
            }
            else
            {
                setError({ status: true, message: "Se ha producido un error al procesar la información. Vuelve a intentarlo" });
            }
        }
        catch(errorS: any)
        {
            // Sin respuesta del servidor (red, timeout) errorS.response no existe
            setError({ status: true, message: (typeof errorS?.response?.data === "string" && errorS.response.data) || "Se ha producido un error al procesar la información. Vuelve a intentarlo" });
        }
        finally
        {
            setSending(false);
        }
    };

    return(<>
        <section className={`${styles.index}`}>
            <BackButton />
            <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">
                    <h2>Competiciones </h2>
                </div>
            </div>
            {loading && <Spinner size={SpinnerSize.large} />}
            {!loading && (<div style={{ display: "flex" }}>
                <div style={{ width: "50%" }}>
                    <article className={`${styles.card} rounded background-background`}>
                        <section className="ms-Grid-row">
                            <h3>Tus datos</h3>
                            <div style={{ display: "flex" }}>
                                <p>Plan de Cartera con el que participas: &nbsp;  </p>
                                <p style={{ color: "#CC214F" }}>{savingPlanName}</p>
                            </div>
                            <div style={{ display: "flex" }}>
                                <p>Cartera Modelo con la que participas: &nbsp;  </p>
                                <p style={{ color: "#CC214F" }}>{portfolioModelName}</p>
                            </div>
                        </section>
                        <section style={{ marginTop: "20px" }} className={`ms-Grid-row`}>
                            <p>Para participar en la competición necesitamos que nos facilites los siguientes datos:</p>
                            <div style={{ display: "flex", flexDirection: "column", marginTop: "10px" }}>
                                <div style={{ display: "flex" }}>
                                    <S.FieldCont>
                                        <TextField
                                            label='Nombre'
                                            // @ts-ignore
                                            styles={InputStyles}
                                            id={'firstName'}
                                            name={'firstName'}
                                            type='text'
                                            value={firstName}
                                            // @ts-ignore
                                            onChange={(e) => setFirstName(e.target.value)}
                                        />

                                    </S.FieldCont>
                                    {haveError && firstName === "" && (
                                        <p style={{ color: "red" }}>Debes rellenar tu nombre</p>
                                    )}
                                    <S.FieldCont>
                                        <TextField
                                            label='Primer Apellido'
                                            // @ts-ignore
                                            styles={InputStyles}
                                            id={'firstLastName'}
                                            name={'firstLastName'}
                                            type='text'
                                            value={lastName}
                                            // @ts-ignore
                                            onChange={(e) => setLastName(e.target.value)}
                                        />

                                    </S.FieldCont>
                                    {haveError && firstName === "" && (
                                        <p style={{ color: "red" }}>Debes rellenar tu apellido</p>
                                    )}
                                </div>
                                <div style={{ display: "flex" }}>
                                    <S.FieldCont>
                                        <TextField
                                            label='Segundo apellido'
                                            // @ts-ignore
                                            styles={InputStyles}
                                            id={'secondLastName'}
                                            name={'secondLastName'}
                                            type='text'
                                            value={secondLastName}
                                            // @ts-ignore
                                            onChange={(e) => setSecondLastName(e.target.value)}
                                        />
                                    </S.FieldCont>
                                    <DatePicker
                                        styles={DatePickerStyle}
                                        label='Fecha de nacimiento'
                                        id={'idExpiration'}
                                        // @ts-ignore
                                        name={'idExpiration'}
                                        formatDate={(date) =>
                                        {
                                            return Moment(date).format('DD/MM/YYYY');
                                        }}
                                        onSelectDate={(date) =>
                                        {
                                            if(date)
                                            {
                                                const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
                                                handleBirthdayChange(utcDate);
                                            }
                                        }}
                                        value={birthDayInDate}
                                        isRequired
                                        strings={DayPickerStrings}
                                        allowTextInput={true}
                                        parseDateFromString={(dateStr) =>
                                        {
                                            var parts: string[] = dateStr.split('-');
                                            var myDate = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
                                            return new Date(myDate)
                                        }}
                                    />
                                    {haveError && birthDayInDate === undefined && (
                                        <p style={{ color: "red" }}>Debes rellenar tu fecha de nacimiento</p>
                                    )}
                                </div>
                                <div style={{ display: "flex" }}>
                                    <CompetitionSelectCont>
                                        <S.Label>Prefijo (país)</S.Label>
                                        <Select
                                            name={'countryPrefix'}
                                            labelField='name'
                                            options={CountryPrefixes}
                                            onChange={(selectedItems) => {selectedItems[0] !== undefined && setCountryPrefix(selectedItems[0].phone_code)}}
                                            dropdownHeight='2000'
                                            searchable={true}
                                            searchBy="text"
                                            noDataLabel={'No encontrado'}
                                            values={CountryPrefixes.filter((cP) => cP.phone_code === (countryPrefix || "+34"))}
                                            placeholder=''
                                            itemRenderer={({item, methods}) =>
                                            (
                                                <span
                                                    role="option"
                                                    aria-selected="false"
                                                    aria-label={item.name + ' ' + item.phone_code}
                                                    // @ts-ignore
                                                    tabIndex="-1"
                                                    className="react-dropdown-select-item"
                                                    onClick={() => methods.addItem(item)}
                                                    key={'country-prefix-' + item.phone_code + '-' + item.iso3}
                                                >
                                                    {item.name + ' ' + item.phone_code}
                                                </span>
                                            )}
                                            required
                                        />
                                        {haveError && mobile === "" &&
                                        (
                                            <p style={{ color: "red" }}>Debes rellenar el prefijo</p>
                                        )}
                                    </CompetitionSelectCont>
                                    <S.FieldPhoneCont>
                                        <TextField
                                            // @ts-ignore
                                            styles={InputStyles}
                                            label='Teléfono móvil'
                                            id={'phone'}
                                            name={'phone'}
                                            type='text'
                                            value={mobile} // @ts-ignore
                                            onChange={(e) => setMobile(e.target.value)} // @ts-ignore
                                            required
                                            validateOnFocusIn
                                        />
                                        {haveError && mobile === "" &&
                                        (
                                            <p style={{ color: "red" }}>Debes rellenar el teléfono móvil</p>
                                        )}
                                    </S.FieldPhoneCont>
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "right",
                                        marginTop: "30px"
                                    }}
                                >
                                    <DefaultButton
                                        className="button tiny-primary-button"
                                        onClick={() => history.push(`/competitions/join/nsv/${competitionId}`)}
                                        disabled={sending || signatureCompetition !== undefined}
                                    >
                                        Cancelar
                                    </DefaultButton>
                                    <DefaultButton
                                        className="button tiny-primary-button"
                                        type="submit"
                                        disabled={sending || signatureCompetition !== undefined}
                                        onClick={participate}
                                    >
                                        {sending && <Spinner size={SpinnerSize.small} className="button-spinner" />}
                                        Participar
                                    </DefaultButton>
                                </div>
                            </div>
                        </section>
                        <ErrorModal
                            title="Ha ocurrido un error al procesar tu solicitud"
                            body={<div><p>{error.message}</p></div>}
                            btnSubmitText="Aceptar"
                            showModal={error.status}
                            onSubmit={() => setError({ status: false, message: "" })}
                            onClose={() => setError({ status: false, message: "" })}
                        />
                    </article>
                    
                </div>
                <div style={{ display: "flex", flexDirection: "column", alignContent: "center", width: "50%" }}>
                    <article
                        className={`ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl3 rounded background-background`}
                        style={{ alignSelf: "center" }}
                    >
                        <CompetitionCardFromCompetition
                            competition={competition}
                            toJoin={true}
							idCompetition={competitionId}
                        />
                    </article>
                </div>
            </div>)}

        </section>
    </>)
}

export default CompetitionInscriptionPromotionated;